import Layout from './components/common/Layout';
import './App.css';

function App() {
  return (
    <Layout />
  );
}

export default App;
